import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: 'Foam',                       label: 'Foam'                        },
  { value: 'NewWeatherstrippingNowick',  label: 'New Weatherstripping Nowick' },
];

const WeatherStrip = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdWeatherStrip">Weather Strip</label>
      <select id="SdWeatherStrip" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default WeatherStrip;
